import React, { useState } from 'react';
import { Link, navigate } from "../components/Router";
import Autosuggest from 'react-autosuggest';
import AutosuggestHighlightMatch from "autosuggest-highlight/umd/match";
import AutosuggestHighlightParse from "autosuggest-highlight/umd/parse";
import searchIcon from '../img/search.svg';
import SimpleBar from 'simplebar-react';
// import 'simplebar/dist/simplebar.min.css';
import { companyLink } from '../components/Links';
import { getAllSymbols, isAllSymbolsLoaded } from '../components/Symbols';
// import companyLogo from "../img/abm-industry.png";
import linkArrowImage from "img/link-arrow.svg";
import { recordEvent } from '../components/Analytics';
import { Spinner } from 'react-bootstrap';
import { AiOutlineWarning } from "react-icons/ai";
import log from 'loglevel';

function getSuggestionValue(suggestion) {
  return `${suggestion.symbol} - ${suggestion.name}`;
}

function autoHighlightParseIt(text, query) {
  const matches = AutosuggestHighlightMatch(text, query);
  return AutosuggestHighlightParse(text, matches);
}

function getHighLightedText(matches) {
  // log.debug("matches:", matches);
  return (
    <>
      {
        matches.map((part, index) => {
          const className = part.highlight ? 'highlight' : null;
          return (
            <span className={className} key={index}>{part.text}</span>
          );
        })
      }
    </>
  );
}

const StatusContainer = ({ value, loadingSymbols, noSuggestions }) => {
  return (
    <div className="status-container">
      {(loadingSymbols || noSuggestions) &&
        <>
          <div className="status">
            <div className="inner-container">
              {loadingSymbols &&
                <>
                  <Spinner animation="border" role="status" className="mr-1">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                  Loading symbols
                </>
              }
              {noSuggestions &&
                <>
                  <AiOutlineWarning className="mr-1" />
                  Nothing found for "{value}"
                </>
              }
            </div>
          </div>
        </>
      }
    </div>
  );
};

const RenderSuggestionItem = ({ exchange, symbol, name }, { query }) => {
  const symbolMatches = autoHighlightParseIt(symbol, query);
  const nameMatches = autoHighlightParseIt(name, query);
  const companyUrl = companyLink(exchange, symbol);
  // log.debug(symbol);

  return (
    <Link to={companyUrl} data-prefetch="true" className="suggest-item">
      {/*
      <div className="invisible cp-image">
        <img className="invisible" src={companyLogo} alt="Company Logo" />
      </div>
      */}

      <div className="cp-info">
        <div className="name-and-label">
          <span className="lbl">{exchange}:{getHighLightedText(symbolMatches)}</span>
          {" "}
          <span className="name">{getHighLightedText(nameMatches)}</span>
        </div>
        <div className="total-call invisible">135 Calls</div>
      </div>

      <div className="icon">
        <img src={linkArrowImage} alt="icon" />
      </div>
    </Link>
  );
};

const RenderSuggestionItemWithoutLink = ({ exchange, symbol, name }, { query }) => {
  const symbolMatches = autoHighlightParseIt(symbol, query);
  const nameMatches = autoHighlightParseIt(name, query);
  // log.debug(symbol);

  return (
    <span className="suggest-item">
      {/*
      <div className="invisible cp-image">
        <img className="invisible" src={companyLogo} alt="Company Logo" />
      </div>
      */}

      <div className="cp-info">
        <div className="name-and-label">
          <span className="lbl">{exchange}:{getHighLightedText(symbolMatches)}</span>
          {" "}
          <span className="name">{getHighLightedText(nameMatches)}</span>
        </div>
        <div className="total-call invisible">135 Calls</div>
      </div>

      <div className="icon">
        <img src={linkArrowImage} alt="icon" />
      </div>
    </span>
  );
};

const filterSymbols = (value, symbols, config = {}) => {
  const { numberSymbolMatches = 3, numberNameMatches = 5 } = config;
  let exactSymbolMatches = [];
  let symbolMatches = [];
  let nameMatches = [];
  const valueLower = value.toLowerCase();
  symbols.forEach((_symbol) => {
    // log.debug(_symbol);
    const { symbol, name } = _symbol;
    const symbolLower = symbol.toLowerCase();
    const nameLower = name.toLowerCase();
    if (valueLower === symbolLower) {
      exactSymbolMatches.push(_symbol);
    } else if (symbolLower.includes(valueLower)) {
      symbolMatches.push(_symbol);
    } else if (nameLower.includes(valueLower)) {
      nameMatches.push(_symbol);
    }
  });
  // log.debug(exactSymbolMatches);
  let result = exactSymbolMatches.splice(0, numberSymbolMatches);
  if (result.length < numberSymbolMatches) {
    result = result.concat(symbolMatches.splice(0, numberSymbolMatches - result.length));
  }
  result = result.concat(nameMatches.splice(0, numberNameMatches));

  return result;
};

// Use this function to render custom suggestions container.
const renderSuggestionsContainer = ({ containerProps, children, query }) => {
  log.trace("renderSuggestionsContainer:", containerProps);
  return (
    <>
      <div {...containerProps}>
        <SimpleBar>
          {children}
        </SimpleBar>
      </div>
    </>
  );
};

const RenderInputComponent = inputProps => (
  <>
    <input {...inputProps} />
  </>
);

const RenderInputComponentWithSearchButton = inputProps => (
  <>
    <input {...inputProps} />
    <div className="input-group-append">
      <button className="btn btn-primary" type="submit" id="button-search-addon">
        <span className="icon">
          <img src={searchIcon} alt="icon" />
        </span>
        <span className="txt">Search</span>
      </button>
    </div>
  </>
);

const SearchBar = ({
    value: initialValue,
    onChange,
    placeholder,
    required,
    id,
    inputClassName,
    renderForm = true,
    renderSearchButton = true,
    renderLinks = true,
  }) => {
  const buildVersion = "1";
  // const { buildVersion } = useRouteData();
  const [ value, setValue ] = useState(initialValue || '');
  const [ suggestions, setSuggestions ] = useState([]);
  const [ loadingSymbols, setLoadingSymbols ] = useState(false);
  const noSuggestions = !loadingSymbols && value && suggestions.length === 0;

  const onChangeEvent = (event, { newValue, method }) => {
    log.trace(`onChange(${event})`)
    if (onChange) {
      onChange(newValue);
    }
    setValue(newValue);
  };

  const loadSuggestions = (query) => {
    log.debug(`loadSuggestions(${query})`);
    if (!isAllSymbolsLoaded()) {
      setLoadingSymbols(true);
    }
    getAllSymbols()
      .then(symbols => {
        setLoadingSymbols(false);
        return symbols;
      })
      .then(symbols => filterSymbols(query, symbols))
      .then(suggestions => {
        const resultsSize = suggestions.length;
        recordEvent({ name: "SearchBarQuery", query, resultsSize, buildVersion });
        return suggestions;
      })
      .then(suggestions => setSuggestions(suggestions));
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    log.trace(`onSuggestionsFetchRequested()`);
    loadSuggestions(value);
  };

  const onSuggestionsClearRequested = () => {
    log.trace(`onSuggestionsClearRequested()`);
  };

  const onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
    log.trace("onSuggestionSelected", event);
    log.debug("onSuggestionSelected", suggestion, suggestionValue, suggestionIndex);
    if (renderLinks) {
      // Prevent a flash of text showing in the input element before the new link is navigated to..
      setValue("");
    }
  };

  const encodeGetParams = p => Object.entries(p).map(kv => kv.map(encodeURIComponent).join("=")).join("&");

  const searchSubmit = (event) => {
    event.preventDefault();
    log.info("searchSubmit:", event);
    const searchParams = {
      q: value,
    }
    navigate(`/search#${encodeURIComponent(value)}`);
  };

  log.trace("SearchBar render() state value:", value, "props value:", initialValue);
  log.debug("SearchBar value:", value);
  const inputProps = {
    placeholder,
    value,
    onChange: onChangeEvent,
    required,
    className: inputClassName,
  };

  // https://github.com/moroshko/react-autosuggest#theme-prop
  const theme = {
    container:                'input-group search-input',
    containerOpen:            '',
    input:                    '',
    inputOpen:                '',
    inputFocused:             '',
    suggestionsContainer:     'suggestions-container',
    suggestionsContainerOpen: 'suggestion-section',
    suggestionsList:          'list-group',
    suggestion:               'list-group-item',
    suggestionFirst:          '',
    suggestionHighlighted:    '',
    sectionContainer:         '',
    sectionContainerFirst:    '',
    sectionTitle:             ''
  };
  if (renderForm) {
    return (
      <form onSubmit={searchSubmit}>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={onSuggestionsFetchRequested}
          onSuggestionsClearRequested={onSuggestionsClearRequested}
          onSuggestionSelected={onSuggestionSelected}
          getSuggestionValue={getSuggestionValue}
          renderSuggestionsContainer={renderSuggestionsContainer}
          renderSuggestion={renderLinks ? RenderSuggestionItem : RenderSuggestionItemWithoutLink}
          renderInputComponent={renderSearchButton ? RenderInputComponentWithSearchButton : RenderInputComponent}
          // Set this to true if you'd like to render suggestions even when the input is not focused. (for testing)
          alwaysRenderSuggestions={false}
          inputProps={inputProps}
          id={id}
          theme={theme}
        />
        <StatusContainer value={value} loadingSymbols={loadingSymbols} noSuggestions={noSuggestions} />
      </form>
    );
  }
  return (
    <>
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        onSuggestionSelected={onSuggestionSelected}
        getSuggestionValue={getSuggestionValue}
        renderSuggestionsContainer={renderSuggestionsContainer}
        renderSuggestion={renderLinks ? RenderSuggestionItem : RenderSuggestionItemWithoutLink}
        renderInputComponent={renderSearchButton ? RenderInputComponentWithSearchButton : RenderInputComponent}
        // Set this to true if you'd like to render suggestions even when the input is not focused. (for testing)
        alwaysRenderSuggestions={false}
        inputProps={inputProps}
        id={id}
        theme={theme}
      />
      {/* <StatusContainer value={value} loadingSymbols={loadingSymbols} noSuggestions={noSuggestions} /> */}
    </>
  );
};

SearchBar.defaultProps = {
  redirectOnSelected: true,
  required: false,
  id: "defaultSearchBar",
};

export default SearchBar;
export {
  getHighLightedText,
  autoHighlightParseIt,
  filterSymbols,
  RenderSuggestionItem,
};
